module.exports = __webpack_public_path__ + "static/media/bot-trade.bcd23407.png";